import { render, staticRenderFns } from "./VisitorChatList.vue?vue&type=template&id=6587f64e"
import script from "./VisitorChatList.vue?vue&type=script&lang=js"
export * from "./VisitorChatList.vue?vue&type=script&lang=js"
import style0 from "./VisitorChatList.vue?vue&type=style&index=0&id=6587f64e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports